let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2F69B"), load("gEi5K")]).then(() => parcelRequire('3nvKi'));